import { render, staticRenderFns } from "./devicesDashboardExerciseForm.vue?vue&type=template&id=8dae5518&scoped=true&xmlns=true"
import script from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
export * from "./devicesDashboardExerciseForm.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardExerciseForm.vue?vue&type=style&index=0&id=8dae5518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dae5518",
  null
  
)

export default component.exports